import { BOX_SHADOW_LITTLE } from "../../../utils/colors";
import { BORDER_RADIUS, BORDER_RADIUS_BUTTON } from "../../../utils/constants";

export const produceCardSx = {
  width: "100%",
  height: "fit-content",
  alignSelf: "start",
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  boxShadow: BOX_SHADOW_LITTLE,
  borderRadius: 3,
  p: 2,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
  overflow: "hidden",
};

export const produceSectionDividerSx = {
  borderTop: "1px solid",
  borderColor: "divider",
  pt: 2,
};

export const produceKickerSx = {
  fontWeight: 700,
  letterSpacing: 0.6,
  textTransform: "uppercase",
  color: "text.secondary",
};

export const produceCardTitleSx = {
  fontWeight: 600,
  fontSize: "1.25rem",
};

export const produceFieldLabelSx = {
  fontWeight: 600,
  fontSize: "0.875rem",
};

export const produceSelectSx = {
  borderRadius: "10px",
};

export const produceResizableMultilineSx = {
  "& .MuiInputBase-inputMultiline": {
    resize: "vertical",
    overflowY: "auto",
  },
};

export const produceTemplateSelectSx = {
  ...produceSelectSx,
  "& .MuiFilledInput-input": {
    paddingTop: "28px",
    paddingBottom: "8px",
  },
};

export const produceChangeButtonSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: 32,
  px: 1.25,
  borderRadius: BORDER_RADIUS_BUTTON,
  border: "1px solid #E4E4E7",
  bgcolor: "#fff",
  color: "text.primary",
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "inherit",
  appearance: "none",
  cursor: "pointer",
  flex: 1,
  minWidth: 0,
  userSelect: "none",
  alignSelf: "stretch",
  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.5,
  },
};

export const produceSelectedTemplateBoxSx = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 1.25,
  p: 1.5,
  borderRadius: 3,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
  boxShadow: BOX_SHADOW_LITTLE,
};

export const produceSummaryBoxSx = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  p: 2,
  borderRadius: BORDER_RADIUS,
  border: "1px solid",
  borderColor: theme.palette.fields.placeholder,
  bgcolor:
    theme.palette.mode === "dark"
      ? theme.palette.action.hover
      : theme.palette.grey[50],
});

export const produceSummaryKickerSx = {
  fontWeight: 600,
  fontSize: "0.75rem",
  color: "text.secondary",
};

export const produceSummaryTotalSx = {
  fontWeight: 700,
  fontSize: "1.5rem",
  lineHeight: 1.2,
  color: "text.primary",
};

export const produceSummaryRowsSx = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
};

export const produceSummaryRowSx = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
  gap: 1,
};

export const produceSummaryCostSx = {
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
  pt: 1.5,
  borderTop: "1px solid",
  borderColor: "divider",
};
